import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';

@Component({
    selector: 'qeditbuttons',
    templateUrl: './q-edit-buttons.component.html',
    styleUrls: ['./q-edit-buttons.component.scss']
})
export class qEditButtonsComponent implements OnInit {

    // Input
    @Input()
    alignButtons: string = 'right';

    // Output
    @Output()
    valueChanged: EventEmitter<any> = new EventEmitter<any>();

    // Utils
    isEditMode: boolean = false;

    constructor(
        private primengConfig: PrimeNGConfig,
    ) { }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
    }

    onEdit() {
        this.isEditMode = true;
        this.onValueChanged('edit');
    }

    onCancel() {
        this.isEditMode = false;
        this.onValueChanged('cancel');
    }

    onSave() {
        this.isEditMode = false;
        this.onValueChanged('save');
    }

    onValueChanged(command: string) {
        this.valueChanged.emit(command);
    }
}
